module.exports = __webpack_public_path__ + "static/media/img-slide1.dcdc43b2.jpg";